import type {
  CreateFollowupRequest,
  FollowupPipelineEntryResponse,
  FollowupResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const followupsApi = {
  listForPerson(personId: string, signal?: AbortSignal) {
    return apiRequest<readonly FollowupResponse[]>(`/people/${personId}/followups`, { signal });
  },

  listPipeline(signal?: AbortSignal) {
    return apiRequest<readonly FollowupPipelineEntryResponse[]>('/people/followups/pipeline', {
      signal,
    });
  },

  create(personId: string, body: CreateFollowupRequest) {
    return apiRequest<FollowupResponse>(`/people/${personId}/followups`, {
      method: 'POST',
      body,
    });
  },
};
